export const ErrorText: React.FC<{
  error?: string;
  className?: string;
}> = ({ error, className }) => {
  return error ? (
    <div>
      <div className={`error-message ${className}`}>{error}</div>
    </div>
  ) : null;
};
